module.exports = __webpack_public_path__ + "static/media/45.80b036a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/45.jpg
// module id = 414
// module chunks = 0